module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_50_60.1d4de1bb.png";